import { Component, ElementRef, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { LanguageService } from '@services/language.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-language-selector',
    templateUrl: 'language-selector.component.html',
    styleUrls: ['./language-selector.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  private languageService = inject(LanguageService);
  private translateService = inject(TranslateService);
  private el = inject(ElementRef);
  private cdr = inject(ChangeDetectorRef);

  public showLanguageDropdown = false;
  public currentLanguage: any;
  public translateServiceSubscriptions: any;

  public languages = [
    {
      title: 'Chinese',
      code: 'cn',
      flag: 'cn'
    },
    {
      title: 'English',
      code: 'en',
      flag: 'uk'
    },
    {
      title: 'German',
      code: 'de',
      flag: 'de'
    },
    {
      title: 'Magyar',
      code: 'hu',
      flag: 'hu'
    },
  ];

  ngOnInit() {
    this.setCurrentLanguage();
    this.translateService.onLangChange.subscribe(() => {
      this.setCurrentLanguage();
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy() {
    if (this.translateServiceSubscriptions) {
      this.translateServiceSubscriptions.unsubscribe();
    }
  }

  changeLanguage(target: EventTarget | null) {
    const lang = (target as HTMLSelectElement).value;
    this.languageService.setLanguage(lang);
  }

  showLanguageDropdownBtnClicked() {
    this.showLanguageDropdown = !this.showLanguageDropdown;
  }

  private setCurrentLanguage() {
    const langCode = this.languageService.getCurrentLanguage();
    for (let language of this.languages) {
      if (language.code === langCode) {
        this.currentLanguage = language;
        return;
      }
    }
  }
}
